ixModuleRouting("impactx.system", {
    "/systemdashboard": {
        template: "<ixa-system-dashboard></ixa-system-dashboard>",
        process: "SystemDashboard",
        workspace: "system",
    },
    "/catalogvalidator": {
        template: "<ixa-catalog-validation></ixa-catalog-validation>",
        templateUrl: "modules/system/templates/catalogvalidation.html",
        controller: "CatalogValidationCtrl",
        controllerAs: "catalogValidationCtrl",
        process: "CatalogValidation",
        workspace: "system",
    },
    "/system/:query?": {
        template: "<ixa-system-info></ixa-system-info>",
        template: "",
        controller: "SystemInfoCtrl",
        noSecurity: true,
    },
    "/logfilebrowser/:path?": {
        template:"<ixa-log-file-browser></ixa-log-file-browser>",
        process: "LogFileBrowser",
    },
    "/editglobalmenu": {
        template: "<ixa-edit-global-menu></ixa-edit-global-menu>",
        process: "EditGlobalMenu",
    },
    "/editgloballobby": {
        template: "<ixa-edit-global-lobby></ixa-edit-global-lobby>",
        process: "EditGlobalLobby",
    },
    "/thirdpartylicences": {
        template: "<ixa-third-party-licenses></ixa-third-party-licenses>",
        process: "ViewThirdPartyLicences",
    },
    "/mfasettings": {
        template: "<ixa-mfa-settings></ixa-mfa-settings>",
        process: "MFASettings",
        workspace: "system",
    },
    "/apitokens": {
        template: "<ixa-api-token-list></ixa-api-token-list>",
        process: "APITokenManager",
        workspace: "system",
    }
});
